import { useState } from "react";

import i18n from "../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Text from "../../../../core/et3-text";
import {
  PASSWORD_BUTTON_FONT_SIZE,
  PASSWORD_BUTTON_HEIGHT,
  PASSWORD_BUTTON_PRESS_OFFSET,
  PASSWORD_BUTTON_RADIUS,
  PASSWORD_BUTTON_SHADOW,
  PASSWORD_TRANSITION
} from "../change-password-constants";

const SubmitButton = withLiteObserverAndTheme<{
  isEnabled: boolean;
  onPress: () => void;
}>((props) => {
  const { isEnabled, onPress, theme } = props;
  const { colors, unitX, unitY } = theme;
  const [isHovered, setIsHovered] = useState(false);
  const [isPressed, setIsPressed] = useState(false);
  const translateY = isEnabled && isPressed ? PASSWORD_BUTTON_PRESS_OFFSET : 0;

  return (
    <button
      disabled={!isEnabled}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => {
        setIsHovered(false);
        setIsPressed(false);
      }}
      onMouseDown={() => setIsPressed(true)}
      onMouseUp={() => setIsPressed(false)}
      onClick={() => onPress()}
      style={{
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: PASSWORD_BUTTON_HEIGHT * unitY,
        border: 0,
        borderRadius: PASSWORD_BUTTON_RADIUS * unitX,
        backgroundColor: isEnabled
          ? colors.all.bondiBlue
          : colors.all.shadeOfGray,
        boxShadow: isEnabled && isHovered ? PASSWORD_BUTTON_SHADOW : "none",
        transform: `translateY(${translateY * unitY}px)`,
        transition: PASSWORD_TRANSITION,
        cursor: isEnabled ? "pointer" : "default"
      }}
    >
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={PASSWORD_BUTTON_FONT_SIZE}
        text={i18n.get("CHANGE_PASSWORD")}
        isSpan={false}
        color={isEnabled ? colors.all.white : colors.all.dimGray}
        style={{ margin: 0 }}
      />
    </button>
  );
});
export default SubmitButton;
